/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_AgeInputs */

const en_field_age = /** @type {(inputs: Field_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age`)
};

const es_field_age = /** @type {(inputs: Field_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edad`)
};

const fr_field_age = /** @type {(inputs: Field_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Âge`)
};

const de_field_age = /** @type {(inputs: Field_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alter`)
};

const ja_field_age = /** @type {(inputs: Field_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年齢`)
};

const zh_field_age = /** @type {(inputs: Field_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年龄`)
};

const ar_field_age = /** @type {(inputs: Field_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العمر`)
};

const id_field_age = /** @type {(inputs: Field_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usia`)
};

const it_field_age = /** @type {(inputs: Field_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Età`)
};

const ru_field_age = /** @type {(inputs: Field_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возраст`)
};

const pt_field_age = /** @type {(inputs: Field_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idade`)
};

const ko_field_age = /** @type {(inputs: Field_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나이`)
};

/**
* | output |
* | --- |
* | "Age" |
*
* @param {Field_AgeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_age = /** @type {((inputs?: Field_AgeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_AgeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_age(inputs)
	if (locale === "es") return es_field_age(inputs)
	if (locale === "fr") return fr_field_age(inputs)
	if (locale === "de") return de_field_age(inputs)
	if (locale === "ja") return ja_field_age(inputs)
	if (locale === "zh") return zh_field_age(inputs)
	if (locale === "ar") return ar_field_age(inputs)
	if (locale === "id") return id_field_age(inputs)
	if (locale === "it") return it_field_age(inputs)
	if (locale === "ru") return ru_field_age(inputs)
	if (locale === "pt") return pt_field_age(inputs)
	return ko_field_age(inputs)
});